import { RJSFSchema } from "shared/types/RJSF"

export function hasAnyFieldError(
  schema: RJSFSchema | RJSFSchema[] | null | undefined
): boolean {
  if (Array.isArray(schema)) {
    return schema.reduce(
      (acc, current) => hasAnyFieldError(current) || acc,
      false
    )
  }

  if (!schema) {
    return false
  }

  if (schema.anyOf && hasAnyFieldError(schema.anyOf)) {
    return true
  }

  if (schema.allOf && hasAnyFieldError(schema.allOf)) {
    return true
  }

  if (schema.oneOf && hasAnyFieldError(schema.oneOf)) {
    return true
  }

  if (!schema.properties) {
    return false
  }

  return Object.values(schema.properties).reduce(
    (acc, propertyValue) =>
      acc ||
      (propertyValue.type === "object"
        ? hasAnyFieldError(propertyValue)
        : !!propertyValue.error),
    false
  )
}
